import styled, { css } from 'styled-components';
import { primary, surfaceLiquid03 } from '../../tokens';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('PaginationDots/PaginationDot');

/**
 * Элемент пагинации точками.
 * Стилизованный компонент, обладающий всеми свойствами ``div``.
 */
export var PaginationDot = /*#__PURE__*/styled.li.withConfig({
  componentId: "plasma__sc-17vit4p-0"
})(["width:0.375rem;height:0.375rem;border-radius:1rem;background:", ";transition:", ";font-size:0.5rem;& + &{margin-left:0.375rem;}&:focus{outline:0 none;}", ""], surfaceLiquid03, function (_ref) {
  var theme = _ref.theme;
  return theme.lowPerformance ? 'unset' : 'width 0.1s ease-in-out, background 0.3s ease-in-out';
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive && css(["width:1.75rem;background:", ";"], primary);
});